import { render, staticRenderFns } from "./EvaluationUpdate.vue?vue&type=template&id=dc960ccc&scoped=true&"
import script from "./EvaluationUpdate.vue?vue&type=script&lang=js&"
export * from "./EvaluationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc960ccc",
  null
  
)

export default component.exports